import React from "react";
import "../../../Styles/ImagePreviewModal.scss";
import ReactDOM from "react-dom";
import { Icon } from "@cadmakers-ui/icons";
import isHotkey from "is-hotkey";
import { Image as APIImage } from "../../../Models/Image";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";

type Props = {
  isOpen: boolean;
  toggle: () => void;
  image: APIImage;
};

type State = {
  image?: HTMLImageElement;
  imageWidth?: string;
  imageHeight?: string;
};

const CLASSNAME_PREFIX = "ImagePreviewModal__";

const isCloseHotkey = isHotkey("esc");

export default class ImagePreviewModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      image: undefined,
      imageWidth: "0px",
      imageHeight: "0px"
    };
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("keydown", this.handleKeyDown, false);

    const img = new Image();
    img.src = this.props.image.fullSizeUrl;
    img.onload = () => {
      this.setState(
        {
          image: img
        },
        () => this.resizeImage(img)
      );
    };
  };

  getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height: height * 0.85
    };
  }

  componentWillUnMount = () => {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this.handleKeyDown);
  };

  handleResize = () => {
    if (!!this.state.image && this.props.isOpen) {
      this.resizeImage(this.state.image);
    }
  };

  handleKeyDown = (event: KeyboardEvent) => {
    if (this.props.isOpen) {
      if (isCloseHotkey(event)) {
        this.props.toggle();
      }
    }
  };

  resizeImage = (image: HTMLImageElement) => {
    const maxSourceWidth = this.getWindowDimensions().width;
    const maxSourceHeight = this.getWindowDimensions().height;

    const widthRatio = maxSourceWidth / image.width;
    const heightRatio = maxSourceHeight / image.height;

    if (image.width > maxSourceWidth && image.height > maxSourceHeight) {
      let newWidth = maxSourceWidth;

      const newWidthRatio = newWidth / image.width;
      let newHeight = image.height * newWidthRatio;

      if (newHeight > maxSourceHeight) {
        newHeight = maxSourceHeight;
        const newHeightRatio = newHeight / image.height;
        newWidth = image.width * newHeightRatio;
      }
      this.setDimensions(newWidth, newHeight);
    } else if (image.width > maxSourceWidth) {
      this.setDimensions(maxSourceWidth, image.height * widthRatio);
    } else if (image.height > maxSourceHeight) {
      this.setDimensions(image.width * heightRatio, maxSourceHeight);
    } else {
      this.setDimensions(image.width, image.height);
    }
  };

  setDimensions = (width: number, height: number) => {
    this.setState({
      imageWidth: `${width}px`,
      imageHeight: `${height}px`
    });
  };

  openExternal = () => {
    window.open(this.props.image.fullSizeUrl, "_blank");
  };

  render() {
    return this.props.isOpen
      ? ReactDOM.createPortal(
          <div className={`${CLASSNAME_PREFIX}overlay`} onClick={this.props.toggle}>
            <div className={`${CLASSNAME_PREFIX}toolbar`} onClick={e => e.stopPropagation()}>
              <div
                className={`${CLASSNAME_PREFIX}toolbar-item`}
                onClick={this.openExternal}
                title="Open in new tab"
              >
                <span className={`${CLASSNAME_PREFIX}toolbar-item-icon`}>
                  <Icon
                    appName="cmThread"
                    assetName="TOOLBAR_ArrowLine"
                    className={iconStyles.smallIcon}
                  />
                </span>
              </div>
              <div
                className={`${CLASSNAME_PREFIX}toolbar-item`}
                title="Close"
                onClick={this.props.toggle}
              >
                <span className={`${CLASSNAME_PREFIX}toolbar-item-icon`}>
                  <Icon
                    appName="GeneralLayout"
                    assetName="GENERAL_L_RemoveX"
                    className={iconStyles.smallIcon}
                  />
                </span>
              </div>
            </div>
            <div className={`${CLASSNAME_PREFIX}wrapper`} onClick={e => e.stopPropagation()}>
              {this.state.image ? (
                <div className={`${CLASSNAME_PREFIX}content`}>
                  <img
                    style={{ width: this.state.imageWidth, height: this.state.imageHeight }}
                    src={this.props.image.fullSizeUrl}
                    alt="Unable to retrieve the image"
                    onClick={this.openExternal}
                    title="Open in new tab"
                  />
                </div>
              ) : (
                <div className={`${CLASSNAME_PREFIX}loader`} />
              )}
            </div>
          </div>,
          document.body
        )
      : null;
  }
}
